module.exports = [
	{
		"id": "2b997c87-c6e8-4d41-a604-b803e94f4447",
		"albumId": "2b997c87-c6e8-4d41-a604-b803e94f4447",
		"slug": "holding-food",
		"caption": "Holding food",
		"alt": "Hands holding a cup of tea",
		"username": "foap",
		"width": 5760,
		"height": 3840,
		"imageUrl": "https://images02.foap.com/images/d0772de5-7d60-4a8b-85f3-49da9290ee9a/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Holding food"
	},
	{
		"id": "4eb79d19-c1ae-49fa-89b0-0791d4962d64",
		"albumId": "4eb79d19-c1ae-49fa-89b0-0791d4962d64",
		"slug": "let-me-have-a-coffee",
		"caption": "Let me have a  coffee",
		"alt": "Fresh coffee",
		"username": "foap",
		"width": 4288,
		"height": 2848,
		"imageUrl": "https://images01.foap.com/images/0b3803f9-b9b5-4b3d-9029-c0ab9520e6d7/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Let me have a  coffee"
	},
	{
		"id": "87ab1ce0-8c9f-4c39-818b-3ad28e0ab047",
		"albumId": "87ab1ce0-8c9f-4c39-818b-3ad28e0ab047",
		"slug": "delicious-pizza",
		"caption": "Delicious Pizza",
		"alt": null,
		"username": "foap",
		"width": 3264,
		"height": 2176,
		"imageUrl": "https://images03.foap.com/images/b7d81cb0-9ca4-480d-8c24-c710e1d3ad19/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Delicious Pizza"
	},
	{
		"id": "d8859682-1211-4131-97bb-ee2f56bbb493",
		"albumId": "d8859682-1211-4131-97bb-ee2f56bbb493",
		"slug": "pregnant-women",
		"caption": "Pregnant Women",
		"alt": "Precious baby boy is almost here ",
		"username": "foap",
		"width": 2294,
		"height": 1536,
		"imageUrl": "https://images01.foap.com/images/64d7e717-10c2-499b-9e5c-482d2a0526e4/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Pregnant Women"
	},
	{
		"id": "04970dd3-b8b9-43cd-baf0-c844bf160020",
		"albumId": "04970dd3-b8b9-43cd-baf0-c844bf160020",
		"slug": "foggy-mornings",
		"caption": "Foggy mornings ",
		"alt": "Mountain ranges in thailand",
		"username": "foap",
		"width": 4608,
		"height": 3456,
		"imageUrl": "https://images02.foap.com/images/9a75fce4-e2a3-4b74-b79c-70cf38b1cca9/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Foggy mornings "
	},
	{
		"id": "c1e35c95-2598-458d-bbd7-91a75444f2df",
		"albumId": "c1e35c95-2598-458d-bbd7-91a75444f2df",
		"slug": "magical-iris",
		"caption": "Magical iris",
		"alt": "Eye on you",
		"username": "foap",
		"width": 3320,
		"height": 2070,
		"imageUrl": "https://images03.foap.com/images/7c880698-e855-4b55-a4dc-ed26f2bde1fe/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Magical iris"
	},
	{
		"id": "3cdb6cb8-718a-4c50-bac2-aca6fd64fe9f",
		"albumId": "3cdb6cb8-718a-4c50-bac2-aca6fd64fe9f",
		"slug": "from-where-i-stand",
		"caption": "From where I stand",
		"alt": null,
		"username": "foap",
		"width": 3264,
		"height": 2448,
		"imageUrl": "https://images01.foap.com/images/f159d5e2-fa41-4b84-bfcb-78a07084a41d/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "From where I stand"
	},
	{
		"id": "41584269-1df1-47fb-83af-08a62e9c5935",
		"albumId": "41584269-1df1-47fb-83af-08a62e9c5935",
		"slug": "majestic-horses",
		"caption": "Majestic Horses",
		"alt": "Horse portrait ",
		"username": "foap",
		"width": 4126,
		"height": 3493,
		"imageUrl": "https://images01.foap.com/images/43227022-576c-46ec-b49a-5c1d6acd49e8/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Majestic Horses"
	},
	{
		"id": "5c999954-0765-428c-a8e7-46022a11fe33",
		"albumId": "5c999954-0765-428c-a8e7-46022a11fe33",
		"slug": "working-hands-close-up",
		"caption": "Working Hands Close-up",
		"alt": null,
		"username": "foap",
		"width": 2832,
		"height": 4256,
		"imageUrl": "https://images03.foap.com/images/bdee23db-aa4c-4230-8a1d-d1bb70819daa/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Working Hands Close-up"
	},
	{
		"id": "30534bdc-073b-4f36-aee1-75136cbd18b2",
		"albumId": "30534bdc-073b-4f36-aee1-75136cbd18b2",
		"slug": "warm-up-flat-lays",
		"caption": "Warm Up Flat lays",
		"alt": null,
		"username": "foap",
		"width": 3264,
		"height": 2448,
		"imageUrl": "https://images02.foap.com/images/7ca22e4b-2ca4-48a0-94a2-04529d8e8d13/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Warm Up Flat lays"
	},
	{
		"id": "fd6d24a7-7a55-40e8-aec5-819dc2f9d6bc",
		"albumId": "fd6d24a7-7a55-40e8-aec5-819dc2f9d6bc",
		"slug": "photo-stories-in-my-city",
		"caption": "Photo Stories in My City",
		"alt": "Not a bad place to stop and enjoy the view. Game rules. ",
		"username": "foap",
		"width": 6000,
		"height": 4000,
		"imageUrl": "https://images03.foap.com/images/7fc686e0-a1cb-4668-a0c9-30e3c69c52cf/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Photo Stories in My City"
	},
	{
		"id": "5ec7f915-2920-4504-8765-4d51e1cc1350",
		"albumId": "5ec7f915-2920-4504-8765-4d51e1cc1350",
		"slug": "amazing-silhouettes",
		"caption": "Amazing Silhouettes!",
		"alt": "On the sunset beach",
		"username": "foap",
		"width": 3264,
		"height": 4928,
		"imageUrl": "https://images03.foap.com/images/4d4615f2-10ad-4974-9b9a-5410bf2fc355/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Amazing Silhouettes!"
	},
	{
		"id": "f1a2389b-6cb6-4f8b-9527-a8971c43d938",
		"albumId": "f1a2389b-6cb6-4f8b-9527-a8971c43d938",
		"slug": "creative-textures",
		"caption": "Creative textures ",
		"alt": "A layer of Stones",
		"username": "foap",
		"width": 3024,
		"height": 4032,
		"imageUrl": "https://images01.foap.com/images/65951abd-67d2-4521-8e8b-9a266e994e2f/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Creative textures "
	},
	{
		"id": "6e0fc49c-506c-4941-8aee-533f0864ecd9",
		"albumId": "6e0fc49c-506c-4941-8aee-533f0864ecd9",
		"slug": "arts-crafts-supply",
		"caption": "Arts & Crafts Supply",
		"alt": "Pencils",
		"username": "foap",
		"width": 1896,
		"height": 1896,
		"imageUrl": "https://images02.foap.com/images/cb2ad689-0184-4589-a112-c8596fef1227/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Arts & Crafts Supply"
	},
	{
		"id": "b023fd5e-91c5-48bd-aac9-19cb2a5a7d4c",
		"albumId": "b023fd5e-91c5-48bd-aac9-19cb2a5a7d4c",
		"slug": "delicious-street-food",
		"caption": "Delicious Street Food",
		"alt": "Donut worry, be happy",
		"username": "foap",
		"width": 2448,
		"height": 3264,
		"imageUrl": "https://images01.foap.com/images/8485e5b7-0541-4c46-b0c2-52584c90ed01/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Delicious Street Food"
	},
	{
		"id": "ebc817cc-36d2-4a2a-914b-58f911a258b4",
		"albumId": "ebc817cc-36d2-4a2a-914b-58f911a258b4",
		"slug": "summertime-ice-cream",
		"caption": "Summertime Ice cream",
		"alt": "Pastel Ice Pop",
		"username": "foap",
		"width": 2905,
		"height": 4351,
		"imageUrl": "https://images02.foap.com/images/791bbe42-fa9a-448b-ada2-23d8b20c36a4/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Summertime Ice cream"
	},
	{
		"id": "4a4ac64f-0aa3-4fe0-8093-548f81ca665b",
		"albumId": "4a4ac64f-0aa3-4fe0-8093-548f81ca665b",
		"slug": "macro-shots",
		"caption": "Macro shots! ",
		"alt": "The entire universe in one tiny spec",
		"username": "foap",
		"width": 2173,
		"height": 1449,
		"imageUrl": "https://images01.foap.com/images/61bea989-7679-46d5-a9ee-f78bfe03b181/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Macro shots! "
	},
	{
		"id": "6d66f163-98e2-4c1f-9367-b307c028870a",
		"albumId": "6d66f163-98e2-4c1f-9367-b307c028870a",
		"slug": "red-color-story",
		"caption": "Red color story",
		"alt": null,
		"username": "foap",
		"width": 2731,
		"height": 2731,
		"imageUrl": "https://images01.foap.com/images/329c5d74-75e6-4d8d-a990-182cb5bfca22/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Red color story"
	},
	{
		"id": "812bb3d9-7a57-462e-a35f-a30339111de4",
		"albumId": "812bb3d9-7a57-462e-a35f-a30339111de4",
		"slug": "fun-with-nails",
		"caption": "Fun with nails",
		"alt": "in the grass",
		"username": "foap",
		"width": 4272,
		"height": 2848,
		"imageUrl": "https://images02.foap.com/images/936ecdee-971f-4932-aea9-787b17a87b22/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Fun with nails"
	},
	{
		"id": "b2f3463f-ac72-400b-81e6-fa1d4306a4e4",
		"albumId": "b2f3463f-ac72-400b-81e6-fa1d4306a4e4",
		"slug": "ingredients",
		"caption": "Ingredients",
		"alt": "Avocado ",
		"username": "foap",
		"width": 2738,
		"height": 1825,
		"imageUrl": "https://images03.foap.com/images/2bb9b142-b783-4748-99b2-fea0b37a5c80/original.jpg?filename=w1920&dw=640",
		"selectedCaption": "Ingredients"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/containers/global/Market/data/curated.json
// module id = 3163
// module chunks = 39